const customerMutations = {
    customerSetMobileMenuShown(state, shown) {
        state.customer.mobileMenuShown = shown;
    },
    customerSetStoredData(state, [prop, value]) {
        state.customer.storedData[prop] = value;
    }
};

export default customerMutations;
